import { IsOptional, IsString } from 'class-validator';

export class FloorPlanUpdateDto {
  @IsOptional()
  @IsString()
  readonly svgData?: string;

  @IsOptional()
  @IsString()
  readonly jsonData?: string;
}
